<template>
  <div class="full-size">
    <div v-if="tabName === 'Atualização de Beneficários'">
      <AtualizaoBeneficiario/>
    </div>
    <div v-if="tabName === 'Gerenciamento de Token'">
      <GerenciamentoToken/>
    </div>
    <!-- <div v-if="tabName === 'Atualização Cadbenef'">
      <AtualizacaoBeneficiarioCadbenef/>
    </div> -->
  </div>
</template>

<script>
import AtualizaoBeneficiario from './AtualizacaoBeneficiario/AtualizacaoBeneficiario';
import GerenciamentoToken from './GerenciamentoToken/GerenciamentoToken';
//import AtualizacaoBeneficiarioCadbenef from './AtualizacaoBeneficiarioCadbenef/AtualizacaoBeneficiarioCadbenef';

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    tabName: {
      type: String,
      default: 'E-mail Áreas'
    }
  },
  components: {
    GerenciamentoToken,
    AtualizaoBeneficiario,
    //AtualizacaoBeneficiarioCadbenef
  }
}
</script>

<style lang="sass" scoped>
.full-size
  width: 100% !important
  max-height: 1000px !important
</style>
